import { ThemeUICSSObject } from '@apia/theme';

export const files: ThemeUICSSObject = {
  '.file-icon': {
    fontFamily: 'Arial, Tahoma, sans-serif',
    fontWeight: 300,
    display: 'inline-block',
    width: '24px',
    height: '32px',
    background: '#018fef',
    position: 'relative',
    borderRadius: '2px',
    textAlign: 'left',
    WebkitFontSmoothing: 'antialiased',
    margin: '2px !important',
  },
  '.file-icon::before': (theme) => {
    return {
      display: 'block',
      content: '""',
      position: 'absolute',
      top: '0',
      right: '0',
      width: '0',
      height: '0',
      borderBottomLeftRadius: '2px',
      borderWidth: '5px',
      borderStyle: 'solid',
      borderTopColor: theme.palette.background.paper,
      borderRightColor: theme.palette.background.paper,
      borderBottomColor: 'rgba(255,255,255,.35)',
      borderLeftColor: 'rgba(255,255,255,.35)',
    };
  },
  '.file-icon::after': {
    display: 'block',
    content: 'attr(data-type)',
    position: 'absolute',
    bottom: '0',
    left: '0',
    fontSize: '10px',
    color: '#fff',
    textTransform: 'lowercase',
    width: '100%',
    padding: '2px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  },
  '.file-icon-xs': { width: '12px', height: '16px', borderRadius: '2px' },
  '.file-icon-xs::before': {
    borderBottomLeftRadius: '1px',
    borderWidth: '3px',
  },
  '.file-icon-xs::after': {
    content: '""',
    borderBottom: '2px solid rgba(255,255,255,.45)',
    width: 'auto',
    left: '2px',
    right: '2px',
    bottom: '3px',
  },
  '.file-icon-sm': { width: '18px', height: '24px', borderRadius: '2px' },
  '.file-icon-sm::before': {
    borderBottomLeftRadius: '2px',
    borderWidth: '4px',
  },
  '.file-icon-sm::after': { fontSize: '7px', padding: '2px' },
  '.file-icon-lg': { width: '48px', height: '64px', borderRadius: '3px' },
  '.file-icon-lg::before': {
    borderBottomLeftRadius: '2px',
    borderWidth: '8px',
  },
  '.file-icon-lg::after': { fontSize: '11px', padding: '4px 6px' },
  '.file-icon-lg-sm': { width: '30px', height: '40px', fontSize: '11px' },
  '.file-icon-xl': { width: '96px', height: '128px', borderRadius: '4px' },
  '.file-icon-xl::before': {
    borderBottomLeftRadius: '4px',
    borderWidth: '16px',
  },
  '.file-icon-xl::after': { fontSize: '24px', padding: '4px 10px' },
  '.file-icon-sm-sm': { height: '18px' },
  '.file-icon[data-type=zip],\n.file-icon[data-type=rar]': {
    background: '#acacac',
  },
  '.file-icon[data-type^=doc],\n.file-icon[data-type^=docx],\n.file-icon[data-type^=odt]':
    {
      background: '#307cf1',
    },
  '.file-icon[data-type^=xls],\n.file-icon[data-type^=xlsx]': {
    background: '#0f9d58',
  },
  '.file-icon[data-type^=ppt]': { background: '#d24726' },
  '.file-icon[data-type=pdf]': { background: '#e13d34' },
  '.file-icon[data-type=txt]': { background: '#5eb533' },
  '.file-icon[data-type=mp3],\n.file-icon[data-type=wma],\n.file-icon[data-type=m4a],\n.file-icon[data-type=flac]':
    {
      background: '#8e44ad',
    },
  '.file-icon[data-type=mp4],\n.file-icon[data-type=wmv],\n.file-icon[data-type=mov],\n.file-icon[data-type=avi],\n.file-icon[data-type=mkv]':
    {
      background: '#7a3ce7',
    },
  '.file-icon[data-type=bmp],\n.file-icon[data-type=jpg],\n.file-icon[data-type=jpeg],\n.file-icon[data-type=gif],\n.file-icon[data-type=png]':
    {
      background: '#f4b400',
    },
};
